import type { Project } from "../../models/Project";

export const projectsData: Project[] = require("./ProjectsData.json");
